module.exports = __webpack_public_path__ + "static/ab7-81e49b5c776a8a26563cb09e144955cc.jpg";